import Cookies from 'js-cookie';
/**
 * 获取咨询页cookie
 */
export var getConsultCookie = function (name, defaultVal) {
    if (defaultVal === void 0) { defaultVal = ''; }
    return Cookies.get(name) || defaultVal;
};
export { generateUuid } from './uuid';
export * from './decodeURIComponentSafe';
